import { useChatbotStore, useChatStateStore, useMessagesStore, useUserStore } from "../zustand/store";
import MarkDownConverter from "./Markdown";
import { MarkDownStreamingConverter } from "./Markdown";
import styles from '../style/styles/ChatBubble.module.css';
import buttonStyles from '../style/styles/Buttons.module.css';
import { useEffect, useRef, useState } from "react";
import { LightCircle } from "./Units/LightCircle";

export const ChatBubble = (props) => {
    const { message, loading } = props;
    const { chatbot } = useChatbotStore();
    const { isBuilder } = useMessagesStore();
    const { isConsole } = useChatStateStore();
    const imageUrl = chatbot?.avatar?.profileAsset || chatbot?.profileImg || '/img/units/gentoo-symbol.png';

    if (loading) {
        return (
            <div className={styles.Bubble__wrapper}>
                <img src={imageUrl} width={32} height={32} alt={chatbot?.name} />
                <div className='spacing-8' />
                <div style={{ width: '100%' }}>
                    <p className={styles.Bubble__name}>{chatbot?.name}</p>
                    <div className='spacing-4' />
                    <LoadingBubble />
                </div>
            </div>
        )
    } else if (message?.message?.length === 0) {
        return null;
    } else {
        return (
            message.isChatbot ?
            <div className={styles.Bubble__wrapper}>
                <img src={imageUrl} width={32} height={32} alt={chatbot?.name} />
                <div className='spacing-8' />
                <div style={{ width: '100%' }}>
                    <div className={styles.Bubble__nameWrapper}>
                        <p className={styles.Bubble__name}>{chatbot?.name}</p>
                        {
                            isConsole && message.isBuilder !== undefined &&
                            <>
                                <div className='spacing-4' />
                                <LightCircle type={message.isBuilder ? 'admin' : 'user'} />
                            </>
                        }
                    </div>
                    <div className='spacing-4' />
                    <div className={styles.Bubble__chatbotMessageWrapper}>
                        {/* <p className={styles.Bubble__chatbotMessage}><MarkDownConverter text={message.message} /></p> */}
                        <MarkDownConverter text={message.message} />
                    </div>
                </div>
            </div> :
            <div className={styles.Bubble__myWrapper}>
                <div className={styles.Bubble__myMessageWrapper}>
                    <p className={styles.Bubble__myMessage}>{message.message}</p>
                </div>
            </div>
        )
    }
}

export const ChatStreamingBubble = (props) => {
    const { loading, chatContainerRef, isAutoScrolling } = props;
    const { chatbot } = useChatbotStore();
    const { streamMessage, isBuilder } = useMessagesStore();
    const { isConsole } = useChatStateStore();
    const imageUrl = chatbot?.avatar?.profileAsset || chatbot?.profileImg || '/img/units/gentoo-symbol.png';
    const [visibleBlockCount, setVisibleBlockCount] = useState(0);
    const [blocks, setBlocks] = useState([]);

    useEffect(() => {
        const streamResponse = document.getElementById('stream-response');
        if (streamResponse) {
            if (isAutoScrolling) {
                chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
            }
        }
    }, [streamMessage]);

    /* useEffect(() => {
        // Split on double newlines, sentence-ending punctuation, and list items
        const splitPattern = /(\n\s*\n|[.?!](?=\s)|\n(?=\s*[-*•]\s)|\n(?=\s*\d+\.\s))/;
        let parts = streamMessage.split(splitPattern);
        
        let blocks = [];
        let currentBlock = '';
        
        for (let i = 0; i < parts.length; i++) {
            let part = parts[i];
            
            if (part.match(/^\n\s*\n$/)) {
                // Paragraph break
                if (currentBlock.trim()) {
                    blocks.push({ text: currentBlock.trim(), hasLineBreak: false });
                    currentBlock = '';
                }
            } else if (part.match(/^[.?!]$/)) {
                // Sentence-ending punctuation
                currentBlock += part;
                if (currentBlock.trim()) {
                    // Check if next part is a newline followed by a list item
                    const nextPart = i + 1 < parts.length ? parts[i + 1] : '';
                    const isBeforeList = nextPart.match(/^\n(?=\s*[-*•]\s)/) || nextPart.match(/^\n(?=\s*\d+\.\s)/);
                    // Check if next part starts with single newline (not double newline)
                    const hasLineBreak = nextPart.match(/^\n(?!\s*\n)/) || isBeforeList;
                    blocks.push({ text: currentBlock.trim(), hasLineBreak: !!hasLineBreak });
                    currentBlock = '';
                }
            } else if (part.match(/^\n(?=\s*[-*•]\s)/) || part.match(/^\n(?=\s*\d+\.\s)/)) {
                // List item break - the previous block should handle the line break
                if (currentBlock.trim()) {
                    blocks.push({ text: currentBlock.trim(), hasLineBreak: false });
                    currentBlock = '';
                }
            } else {
                // Regular text
                currentBlock += part;
            }
        }
        
        // Add any remaining content
        if (currentBlock.trim()) {
            blocks.push({ text: currentBlock.trim(), hasLineBreak: false });
        }
        
        // Post-process to fix hasLineBreak for blocks followed by lists
        for (let i = 0; i < blocks.length - 1; i++) {
            const currentBlock = blocks[i];
            const nextBlock = blocks[i + 1];
            
            // If next block starts with a list item, current block needs line break
            if (nextBlock.text.match(/^\s*[-*•]\s/) || nextBlock.text.match(/^\s*\d+\.\s/)) {
                currentBlock.hasLineBreak = true;
            }
        }
        
        // Merge short blocks (2 characters or less) with previous blocks
        let processedBlocks = [];
        for (let block of blocks) {
            if (block.text.length <= 2 && processedBlocks.length > 0) {
                processedBlocks[processedBlocks.length - 1].text += ' ' + block.text;
                if (block.hasLineBreak) {
                    processedBlocks[processedBlocks.length - 1].hasLineBreak = true;
                }
            } else {
                processedBlocks.push(block);
            }
        }
        
        setBlocks(processedBlocks);
    }, [streamMessage]); */

    /* useEffect(() => {
        //console.log('blocks', blocks);
        //console.log('visibleBlockCount', visibleBlockCount);
        if (visibleBlockCount < blocks.length - 1) {
            setVisibleBlockCount(Math.max(0, blocks.length - 1));
        }
    }, [visibleBlockCount, blocks]); */

    return (
        <div className={styles.Bubble__wrapper}>
            <img src={imageUrl} width={32} height={32} alt={chatbot?.name} />
            <div className='spacing-8' />
            <div style={{ width: '100%' }}>
                <div className={styles.Bubble__nameWrapper}>
                    <p className={styles.Bubble__name}>{chatbot?.name}</p>
                    {
                        isConsole && isBuilder !== undefined &&
                        <>
                            <div className='spacing-4' />
                            <LightCircle type={isBuilder ? 'admin' : 'user'} />
                        </>
                    }
                </div>
                <div className='spacing-4' />
                {
                    loading ?
                    <LoadingBubble /> :
                    <div className={styles.Bubble__chatbotMessageWrapper} id='stream-response' >
                        {/* <p id='stream-response' className={styles.Bubble__chatbotMessage}><MarkDownConverter text={message} /></p> */}
                        <MarkDownConverter text={streamMessage}/>
                        {/* <MarkDownStreamingConverter 
                            text={blocks.slice(0, visibleBlockCount)
                                .map((block, index) => {
                                    if (index === blocks.slice(0, visibleBlockCount).length - 1) {
                                        return block.text;
                                    }
                                    return block.text + (block.hasLineBreak ? '\n' : ' ');
                                })
                                .join('')
                            } 
                        /> */}
                        {/* {
                            blocks.slice(0, visibleBlockCount).map((block, index) => (
                                <div 
                                    key={index} 
                                    className={styles.Bubble__streamingBlock}
                                    style={{ display: block.hasLineBreak ? 'block' : 'inline' }}
                                >
                                    <MarkDownStreamingConverter text={block.text} />
                                </div>
                            ))
                        } */}
                    </div>
                }
            </div>
        </div>
    )
}

export const GreetingBubble = () => {
    const { chatbot } = useChatbotStore();
    const { isConsole, customizedGreeting, clearCustomizedGreeting } = useChatStateStore(); // 🧪 맞춤형 그리팅 추가
    const imageUrl = chatbot?.avatar?.profileAsset || chatbot?.profileImg || '/img/units/gentoo-symbol.png';

    const greetingMessage = customizedGreeting || 
        (isConsole ? chatbot?.consoleGreeting?.default : chatbot?.greetingMessage);

    useEffect(() => {
        return () => {
            clearCustomizedGreeting();
        };
    }, [clearCustomizedGreeting]);

    return (
        <div className={styles.Bubble__wrapper}>
            <img src={imageUrl} width={32} height={32} alt={chatbot?.name} />
            <div className='spacing-8' />
            <div>
                <div className={styles.Bubble__nameWrapper}>
                    <p className={styles.Bubble__name}>{chatbot?.name}</p>
                </div>
                <div className='spacing-4' />
                <div className={styles.Bubble__chatbotMessageWrapper}>
                    <MarkDownConverter text={greetingMessage} />
                </div>
            </div>
        </div>
    )
}

export const TailBubble = (props) => {
    const { message } = props;
    const { setIsFormSubmitted } = useChatStateStore();
    const { partnerType } = useUserStore();

    return (
        message?.length > 0 &&
        <>
            <div className={buttonStyles.TailBubble__wrapper}>
                <div className='spacing-32' />
                <div className='spacing-8' />
                <div>
                    <div className={styles.Bubble__chatbotMessageWrapper}>
                        <p className={styles.Bubble__chatbotMessage}>{message}</p>
                    </div>
                </div>
            </div>
            {
                partnerType === 'fastfive' &&
                <div className={buttonStyles.TailBubble__buttonWrapper}>
                    <div className='spacing-32' />
                    <div className='spacing-8' />
                    <button
                        className={buttonStyles.TailBubble__button}
                        onClick={() => setIsFormSubmitted('ready')}
                    >
                        <p className="h4 fc-white">💥 사무실 최저가 견적 받기</p>
                    </button>
                </div>
            }
        </>
    )
}

export const LoadingBubble = () => {
    const { chatbot } = useChatbotStore();
    const imageUrl = chatbot?.avatar?.profileAsset || chatbot?.profileImg || '/img/units/gentoo-symbol.png';
    return (
        <div className={styles.Bubble__wrapper}>
            <img src={imageUrl} width={32} height={32} alt={chatbot?.name} />
            <div className='spacing-8' />
            <div style={{ width: '100%' }}>
                <p className={styles.Bubble__name}>{chatbot?.name}</p>
                <div className='spacing-4' />
                <div className={styles.Bubble__chatbotMessageWrapper}>
                    <div className={styles.typingIndicator}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    )
}